import { z } from 'zod';

export const addUserSchema = z.object({
  email: z
    .string()
    .email('Invalid email format')
    .min(5, 'Email must be at least 5 characters')
    .max(254, 'Email must be at most 254 characters'),
});

export type AddUserFormData = z.infer<typeof addUserSchema>;
